const actionTypeIdentifier = '8842C1BF-4C51-4DAE-BFA4-82A28FAADE42';

export const getHRDetails = `GET-HR-DETAILS-${actionTypeIdentifier}`;
export const getCostCenterDropdown = `GET-HR-COST-CENTER-DROPDOWN-${actionTypeIdentifier}`;
export const getStatusDropdown = `GET-HR-STATUS-DROPDOWN-${actionTypeIdentifier}`;
export const getLineManagerDropdown = `GET-HR-LINE-MANAGER-DROPDOWN-${actionTypeIdentifier}`;
export const getApproverCostCenterAuthorizerDropdown = `GET-HR-APPROVER-CC-AUTHORIZER-DROPDOWN-${actionTypeIdentifier}`;
export const getApproverWirelineDropdown = `GET-HR-APPROVER-WIRELINE-DROPDOWN-${actionTypeIdentifier}`;
export const getLocationAddressDropdown = `GET-HR-LOCATION-ADDRESS-DROPDOWN-${actionTypeIdentifier}`;
export const getFirstLineManagerDropdownList = `GET-FIRST-LINE-MANAGER-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const getLocationAddressDropdownList = `GET-LOCATION-ADDRESS-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const getRoleDropdown = `GET-ROLE-DROPDOWN-${actionTypeIdentifier}`;
export const resetFetchingHrDetails = `RESET-HR-DETAILS-${actionTypeIdentifier}`;
export const setLineManagerLoading = `SET-LINE-MANAGER-LOADING-${actionTypeIdentifier}`;
export const setLocationLoading = `SET-LOCATION-LOADING-${actionTypeIdentifier}`;
export const resetForm = `RESET-FORM-${actionTypeIdentifier}`;
export const hrDetailsFormModel = {
    employeeId: 0,
    userId: 0,
    hrSapId: '',
    firstName: '',
    lastName: '',
    middleInitial: '',
    emailAddress: '',
    jobTitle: '',
    costCenterId: '',
    costCenterDisplay: '',
    costCenterAuthorizer: '',
    statusId: 0,
    hireDate: '',
    dateLeft: '',
    isVIP: false,
    firstLineManagerHrId: '',
    firstLineManagerFullName: '',
    firstLineManagerEmailAddress: '',
    firstLineManagerStatus: '',
    secondLineManagerHrId: '',
    secondLineManagerFullName: '',
    secondLineManagerEmailAddress: '',
    secondLineManagerStatus: '',
    approverCostCenterAuthorizer: false,
    approverWireline: false,
    locationId: 0,
    locationSiteId: '',
    address1: '',
    address2: '',
    locationType: '',
    city: '',
    state: '',
    country: '',
    zip: '',
    role: '',
    roleId: '',
};